import _styled from '@emotion/styled-base';
import React__default from 'react';
import { Tag } from '@blueprintjs/core';
import { borderRadiusFull } from '../theme/theme.js';
import { Text } from '../text/text.js';

var ConditionBuilderCombinatorWrapper = /*#__PURE__*/_styled("div", {
  target: "emuypuu0"
})("position:relative;display:flex;align-items:center;height:", function (_ref) {
  var readOnly = _ref.readOnly,
      vertical = _ref.vertical;
  return readOnly && vertical ? undefined : "2rem";
}, ";border-radius:", borderRadiusFull, ";.vds-condition-builder-header > &{height:", function (_ref2) {
  var combinatorEditable = _ref2.combinatorEditable,
      readOnly = _ref2.readOnly;
  return (!combinatorEditable || readOnly) && "auto";
}, ";}.vds-condition-builder-group:first-child > .vds-condition-builder-header > &{display:none;}.vds-condition-builder-header &{height:", function (_ref3) {
  var combinatorEditable = _ref3.combinatorEditable,
      readOnly = _ref3.readOnly;
  return combinatorEditable && !readOnly && "2rem";
}, ";margin-left:-0.25rem;}");

var ConditionBuilderCombinatorTag = /*#__PURE__*/_styled(Tag, {
  target: "emuypuu1"
})({
  name: "9ec6lk",
  styles: "width:2.625rem;text-align:center;.vds-condition-builder-rule:nth-child(2) &,.vds-condition-builder-group:nth-child(2) > .vds-condition-builder-header > .vds-condition-builder-combinator > &{visibility:hidden;> *{display:none;}}"
});

var ConditionBuilderCombinator = function ConditionBuilderCombinator(_ref4) {
  var andCombinatorTagText = _ref4.andCombinatorTagText,
      combinator = _ref4.combinator,
      _ref4$combinatorEdita = _ref4.combinatorEditable,
      combinatorEditable = _ref4$combinatorEdita === void 0 ? true : _ref4$combinatorEdita,
      orCombinatorTagText = _ref4.orCombinatorTagText,
      readOnly = _ref4.readOnly,
      vertical = _ref4.vertical;
  return /*#__PURE__*/React__default.createElement(ConditionBuilderCombinatorWrapper, {
    className: "vds-condition-builder-combinator",
    combinatorEditable: combinatorEditable,
    readOnly: readOnly,
    vertical: vertical
  }, /*#__PURE__*/React__default.createElement(ConditionBuilderCombinatorTag, {
    className: "vds-condition-builder-combinator-tag ".concat(combinator === "all" ? "vds-highlight-06" : "vds-highlight-05")
  }, /*#__PURE__*/React__default.createElement(Text, {
    ellipsize: true
  }, combinator === "all" ? andCombinatorTagText : orCombinatorTagText)));
};

export { ConditionBuilderCombinator };
//# sourceMappingURL=condition-builder-combinator.js.map
